module.exports = __webpack_public_path__ + "img/全屋.111733e9.webp";